// ABOUTME: Conditional pagination controls using MUI Pagination.
// ABOUTME: Renders nothing when there is only one page of data.
import MuiPagination from '@mui/material/Pagination'
import Box from '@mui/material/Box'

interface Props {
  page: number
  totalPages: number
  onChange: (page: number) => void
}

export function Pagination({ page, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null

  return (
    <Box display="flex" justifyContent="center" mt={2}>
      <MuiPagination
        count={totalPages}
        page={page}
        onChange={(_event, value) => onChange(value)}
      />
    </Box>
  )
}
